module.exports = __webpack_public_path__ + "static/media/libro.ab0819d5.svg";